// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"746":"1e0d4644","929":"da872991"}[chunkId] + ".chunk.css";
};